import { render } from "./AddStore.vue?vue&type=template&id=ba4452fa"
import script from "./AddStore.vue?vue&type=script&lang=js"
export * from "./AddStore.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__